import Image from "next/image";
import Link from "next/link";

type Props = {
  title: string;
  content: string;
  btnText: string;
  href: string;
  onClick: () => void;
};

export const CallToActionVariant1 = ({ title, content, btnText, href, onClick }: Props) => {
  return (
    <>
      <article className="grid grid-cols-1 overflow-hidden rounded-2xl bg-brand-surface-cyan md:grid-cols-2">
        <div className="order-2 grid items-center px-8 py-8 md:order-1 md:px-16">
          <div>
            <h2 className="text-title-lg font-bold md:text-section-mobile">{title}</h2>
            <p className="mb-10 mt-2 text-body-lg">{content}</p>
            <Link
              href={href}
              onClick={onClick}
              className="inline-block rounded-lg bg-primary px-4 py-2 text-title font-bold text-white transition-colors duration-200 ease-in-out hover:bg-secondary"
            >
              {btnText}
            </Link>
          </div>
        </div>
        <Image
          className="mask-image order-1 h-full w-full object-cover md:order-1"
          src={"/images/cta.webp"}
          alt=""
          width={1088}
          height={621}
        />
      </article>
    </>
  );
};
export const CallToActionVariant2 = ({ title, content, btnText, href, onClick }: Props) => {
  return (
    <article className="rounded-2xl bg-[url('/images/bg_cta_2.webp')] bg-cover bg-center bg-no-repeat px-4 py-5 text-center text-white md:px-16 md:py-20">
      <h2 className="text-title-lg font-bold md:text-section-mobile">{title}</h2>
      <p className="mb-10 mt-2 text-body-lg">{content}</p>
      <Link
        href={href}
        onClick={onClick}
        className="inline-block rounded-lg bg-primary px-4 py-2 text-title font-bold text-white transition-colors duration-200 ease-in-out hover:bg-secondary"
      >
        {btnText}
      </Link>
    </article>
  );
};
